import React, { HTMLAttributes } from 'react';
import { styled } from '@mui/material';

import SkeletonBase from '@mui/material/Skeleton';
import { User } from '@bimdata/definitions/dto';
import AvatarBase from '@/components/Avatar';
import Subtitle from '@/components/Subtitle';
import { UserStatus } from '@bimdata/definitions/const';
import Highlighter from './Highlighter';

const UserCardContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
});

const Avatar = styled(AvatarBase)({
  fontSize: '19px',
  width: '40px',
  height: '40px',
});

const Skeleton = styled(SkeletonBase)({
  fontSize: '19px',
  width: '40px',
  height: '40px',
});

const FullName = styled('span')({
  margin: 0,
  padding: 0,
  textOverflow: 'ellipsis',
  overflowX: 'clip',
});

const TextBlock = styled('div')(({ blocked }: { blocked?: boolean }) => ({
  overflow: 'hidden',
  textDecoration: blocked ? 'line-through currentColor' : 'none',
}));

export type UserCardProps = HTMLAttributes<HTMLDivElement> & {
  profile: User;
  hideEmail?: true;
  blocked?: boolean;
  avatar?: string | false;
  highlight?: string | RegExp;
}

export default ({ avatar, profile, blocked, hideEmail, highlight, ...props }: UserCardProps) => {
  const fullName = (profile.fullName !== profile.email || profile.status !== UserStatus.ACTIVE) && profile.fullName || '';
  return (<UserCardContainer {...props}>
    {(typeof avatar === 'string' || avatar === false)
      ? <Avatar source={avatar || null} profile={profile} />
      : <Skeleton variant='circular' />
    }
    {
    <TextBlock blocked={blocked}>
      <FullName className="UserCard-fullname">
        {highlight ? <Highlighter pattern={highlight}>{fullName}</Highlighter> : fullName}
      </FullName>
      {(!hideEmail && profile.status === UserStatus.ACTIVE) && (
        <Subtitle>{highlight ? <Highlighter pattern={highlight}>{profile.email}</Highlighter> : profile.email}</Subtitle>
      )}
    </TextBlock>
    }
  </UserCardContainer>);
};